import { useId } from 'react'
import type { ReactElement } from 'react'
import { CITY } from '@city'
import { DesktopPromptFrame } from './DesktopPromptFrame'
import { PromptBenefitList } from './PromptBenefitList'
import { PROMPT_COPY } from './promptCopy'
import qrDesktop1 from './assets/qr-desktop-1.svg'
import styles from './DesktopBenefitsPrompt.module.css'

/**
 * Desktop, variant 1 — benefits + QR (Figma 9360:77922 / 9361:17829, dialog
 * 9354:77726). The app icon sits on the card's top edge, half outside it.
 */
export function DesktopBenefitsPrompt({ onClose }: { readonly onClose: () => void }): ReactElement {
  const titleId = useId()
  return (
    <DesktopPromptFrame labelledBy={titleId} variant="v1" onClose={onClose}>
      <span className={styles.icon}>
        <img className={styles.iconLight} src={CITY.appIcon.light} alt="" />
        <img className={styles.iconDark} src={CITY.appIcon.dark} alt="" />
      </span>
      <div className={styles.body}>
        <div className={styles.heading}>
          <h2 id={titleId} className={styles.title}>
            {PROMPT_COPY.desktop1.title}
          </h2>
          <p className={styles.subtitle}>{PROMPT_COPY.desktop1.subtitle}</p>
        </div>
        <div className={styles.row}>
          <div className={styles.benefits}>
            <PromptBenefitList
              benefits={PROMPT_COPY.home.benefits}
              layout="stacked"
              size="desktop"
            />
          </div>
          <div className={styles.qrCard}>
            <img className={styles.qr} src={qrDesktop1} alt="" width={192} height={192} />
            <p className={styles.qrTitle}>{PROMPT_COPY.desktop1.qrTitle}</p>
            <p className={styles.qrDetail}>{PROMPT_COPY.desktop1.qrDetail}</p>
          </div>
        </div>
      </div>
    </DesktopPromptFrame>
  )
}
